import { render, staticRenderFns } from "./Firmwares.vue?vue&type=template&id=3ca8e490&scoped=true&"
import script from "./Firmwares.vue?vue&type=script&lang=ts&"
export * from "./Firmwares.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca8e490",
  null
  
)

export default component.exports